module.exports = __webpack_public_path__ + "static/media/reg6.cbcde145.jpg";